import React from "react";
import Header from "@/components/landing/Header";
import SpaceSection from "@/components/landing/SpaceSection";
import ForWhomSection from "@/components/landing/ForWhomSection";
import UnitySection from "@/components/landing/UnitySection";
import WhyMattersSection from "@/components/landing/WhyMattersSection";
import NextPageCTA from "@/components/landing/NextPageCTA";
import PageFooter from "@/components/landing/PageFooter";
import RelatedPages from "@/components/landing/RelatedPages";
import { ABOUT_PAGES } from "@/data/navigation";

export default function Space() {
  return (
    <main className="bg-warm text-graphite min-h-screen">
      <Header />
      <div className="pt-24 md:pt-28" />
      <SpaceSection />
      <ForWhomSection />
      <UnitySection />
      <WhyMattersSection />
      <NextPageCTA testId="next-page-cta-space" />
      <RelatedPages
        pages={ABOUT_PAGES.filter((p) => p.to !== "/milyen-terbe-erkezel")}
        testId="related-pages-space"
      />
      <PageFooter />
    </main>
  );
}
